// @flow
import React, {PureComponent} from 'react';
import {Image, StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import {Frame} from '../../../components/common';
import {Separator} from '../../../components/signUp';
import config from '../../../config';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import VouchersFrame from '../../Vouchers/components/VouchersFrame';
import FullButton from './PanelFullButton';

type State = {
  containerWidth: ?number,
};

type Props = StateProps & DispatchProps;

export type DispatchProps = {
  goToSignUp: Function,
  goToSimActivation: Function,
};

export type StateProps = {
  isInitializingSignUp: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    frameContainer: {
      paddingVertical: 12,
      paddingHorizontal: 8,
    },
    image: {
      height: 100,
      width: 100,
      resizeMode: 'contain',
    },
    text: {
      color: theme.frame.textColor,
      fontSize: 16,
      textAlign: 'center',
      marginVertical: 7,
    },
    secondColumn: {
      paddingHorizontal: 8,
    },
    button: {
      marginVertical: 7,
    },
  });

class NoPendingDeliveryPanel extends PureComponent<Props, State> {
  styles = getStyles();

  state = {containerWidth: null};

  measure = ({nativeEvent}: any) =>
    this.setState({containerWidth: nativeEvent.layout.width});

  renderVouchersFrame = () => {
    return this.props.filteredAvailableVouchers &&
      this.props.filteredAvailableVouchers.length > 0 ? (
      <VouchersFrame comeFrom="dashboard" />
    ) : null;
  };

  render() {
    const styles = this.styles;
    return (
      <Frame style={styles.frameContainer}>
        <View style={styles.container} onLayout={this.measure}>
          <Image
            style={[
              styles.image,
              this.state.containerWidth != null && {
                width: Math.min(100, this.state.containerWidth / 3),
              },
            ]}
            source={theme.noPendingImage}
          />
          <View
            style={[
              styles.secondColumn,
              this.state.containerWidth != null && {
                width: (2 * this.state.containerWidth) / 3,
              },
            ]}>
            <Text style={styles.text}>
              {I18n.t('Dashboard.NoPendingDeliveryPanel.title')}
            </Text>
            <FullButton
              style={styles.button}
              secondaryColors
              text={I18n.t('Dashboard.NoPendingDeliveryPanel.orderSim')}
              onPress={this.props.goToSignUp}
              isLoading={this.props.isInitializingSignUp}
            />
            {config.canActivateWithAnAccountWithoutSubscriptions && (
              <FullButton
                style={styles.button}
                secondaryColors
                text={I18n.t('Dashboard.NoPendingDeliveryPanel.activateSim')}
                onPress={this.props.goToSimActivation}
              />
            )}
          </View>
        </View>
        {this.renderVouchersFrame()}
      </Frame>
    );
  }
}

export default NoPendingDeliveryPanel;
